// 选手列表
const playerList = 'player/list';
// 选手详情
const playerInfo = 'player/details';

export {
  playerList,
  playerInfo
}